import angular from 'angular';
import headerSecondaryComponent from './headerSecondary.component';

const headerSecondaryModule = angular.module('headerSecondary', [])

.component('headerSecondary', headerSecondaryComponent);

export default headerSecondaryModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/headerSecondary/headerSecondary.js
 **/